export const site = {
  name: 'MaytoMation',
  url: 'https://maytomation.com',
  email: 'hello@maytomation.com',
  phone: 'Phone scheduled through consultation request',
  region: 'Massachusetts',
  description:
    'MaytoMation builds practical software, automation, infrastructure, networking, AI systems, managed hosting, and long-term technical support for Massachusetts businesses.',
  keywords: [
    'Massachusetts software development',
    'Massachusetts automation company',
    'Massachusetts managed hosting',
    'Massachusetts infrastructure services',
    'Massachusetts networking company',
    'custom software Massachusetts',
    'contractor automation systems',
    'business automation Massachusetts'
  ]
};

export const navigation = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Projects', href: '/projects' },
  { label: 'Blog', href: '/blog' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' }
];

export const serviceNav = [
  { label: 'Automation', href: '/services/automation' },
  { label: 'Infrastructure', href: '/services/infrastructure' },
  { label: 'AI Systems', href: '/services/ai-systems' },
  { label: 'Network & WiFi', href: '/services/network-wifi' },
  { label: 'Homelab', href: '/services/homelab' }
];
